import React from 'react'
import SideNav from './SideNav'

const TwoBHKInteriorDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-two-bhkinterior-design parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    2BHK Interior Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us.html" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us.html" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="imgs/two-bhkinterior-design.jpg" alt="" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Your 2 BHK home is more than just living space—it’s where
                      memories are created, families grow, and comfort meets style. At
                      MeHome, with 15+ years of proven expertise, we specialize in
                      designing and executing interiors that make your 2 BHK not only
                      beautiful but also practical and long-lasting.
                    </p>
                    <p className="wow fadeInUp">
                      We believe that a home should reflect who you are, which is why
                      our designs combine creativity, functionality, and attention to
                      detail, ensuring that every room speaks your language of comfort
                      and elegance.
                    </p>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Why 2 BHK Homes <span>Need Special Design</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Unlike 1 BHK homes, a 2 BHK provides flexibility and extra
                      space—but without the right planning, it can feel underutilized
                      or cluttered. That’s where MeHome steps in:
                    </p>
                    <ul>
                      <li>Optimizing Space: Smart layouts that create openness while keeping everything organized.</li>
                      <li>Balancing Style &amp; Function: Interiors that look stunning yet work seamlessly for everyday living.</li>
                      <li>Future-Ready Designs: Flexible setups to adapt as your family grows or lifestyle changes.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our 2BHK <span>Interior Design Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🛋️</div>
                        <div className="why-choose-item-content">
                          <h3>Living Room</h3>
                          <p>
                            We create inviting living spaces perfect for family time
                            and entertaining guests. Expect modern TV units, statement
                            walls, elegant false ceilings, and premium lighting setups.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🛏️</div>
                        <div className="why-choose-item-content">
                          <h3>Bedroom</h3>
                          <p>
                            Designed as personal sanctuaries, our bedrooms include
                            smart storage, space-saving wardrobes, cozy furniture, and
                            soothing décor themes for restful sleep.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🍳</div>
                        <div className="why-choose-item-content">
                          <h3>Modular Kitchen</h3>
                          <p>
                            We design ergonomic kitchens with ample storage, easy
                            accessibility, and stylish finishes. Whether L-shaped,
                            U-shaped, or parallel, we make sure your kitchen is both
                            practical and elegant.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🚿</div>
                        <div className="why-choose-item-content">
                          <h3>Bathrooms</h3>
                          <p>
                            Compact yet luxurious bathrooms with modern fittings,
                            vanity units, and creative tiling that bring comfort and
                            style together.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🪑</div>
                        <div className="why-choose-item-content">
                          <h3>Dining Area</h3>
                          <p>
                            Beautiful dining zones that merge seamlessly with your
                            home’s flow—whether open layouts or partitioned, they’re
                            designed for both elegance and convenience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🌿</div>
                        <div className="why-choose-item-content">
                          <h3>Balconies</h3>
                          <p>
                            Transform balconies into mini lounges, gardens, or reading
                            nooks with smart furniture and décor enhancements.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why MeHome is Perfect for <span>2BHK Interior Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>15+ Years of Industry Experience </b>– Trusted by hundreds of happy homeowners.</li>
                        <li><b>Compact Space Experts </b>– Specialized designs for small apartments.</li>
                        <li><b>End-to-End Services </b>– From planning, 3D visualization, and construction to finishing.</li>
                        <li><b>Affordable Luxury </b> – Premium interiors designed within your budget.</li>
                        <li><b>On-Time Execution </b>– Hassle-free project delivery, every time.</li>
                        <li><b>Quality Craftsmanship </b> – Durable materials and flawless workmanship.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                 <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default TwoBHKInteriorDesigns
